import axiosInstance from "@/config/axios";

export const RequireEditDocs = async (data: {
    editId: string
    editRequestType: string,
    pendingReason: string,
    documentFile: string
    editRequestStatus: string
}) => {
    try {
        const response = await axiosInstance.post('/edit-requests', data)
        return response.data
    } catch (error) {
        return error
    }
}

export const GetAllRequireDocs = async () => {
    try {
        const respone = await axiosInstance.get('edit-requests')
        return respone.data
    } catch (error) {
        return error
    }
}